//
//
//
//
//
//
//
//
//

    import { getGuide } from '@/api/public'

    export default {
      name: 'guide',
      data () {
        return {
          identity: null,
          language: null,
          doc: ''
        }
      },
      mounted () {
        this.identity = this.$route.params.identity
        this.language = this.$route.params.language
        this.getGuide()
      },
      methods: {
        // 获取新手指引内容
        getGuide () {
          getGuide(this.identity, this.language).then(res => {
            this.doc = res.data
          })
        }
      }
    }



// WEBPACK FOOTER //
// ./src/components/guide/index.vue